import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { OrderingOption } from 'generated/graphql-types';
import { presenceContactsRoute } from 'src/app/app-routing.module';
import { CurrentUser } from 'src/app/authentication/models/current-user.interface';
import { RegisterOptions } from 'src/app/common-components/register/models/register-options';
import { EntityRegisterView } from 'src/app/common-components/register/models/register-view';
import { EditPresenceContactPrivileges, PresenceContactPrivileges } from '../models/presence-contact-privileges';
import { PresenceContactRegisterOptions } from '../models/presence-contact-register-options';
import { PresenceContactRegisterListItem } from '../models/presence-contact-register-results.model';
import { selectQuickFilters } from '../state/presence-contact-register.reducer';

@Component({
    encapsulation: ViewEncapsulation.None,
    selector: 'ndt-presence-contact-register-view',
    styleUrls: ['./presence-contact-register-view.component.scss'],
    templateUrl: './presence-contact-register-view.component.html',
    standalone: false
})
export class PresenceContactRegisterViewComponent extends EntityRegisterView<
   PresenceContactRegisterListItem,
   PresenceContactRegisterOptions,
   OrderingOption
> {
   protected selectQuickFilters(): (state: object) => RegisterOptions | null {
      return selectQuickFilters;
   }
   @Input() presenceContactPrivileges: PresenceContactPrivileges;
   @Input() editPresenceContactPrivileges: EditPresenceContactPrivileges;
   @Input() currentUser: CurrentUser;

   @Output() openDialog = new EventEmitter<{ callDetail: any }>();
   @Output() initiateDirectedCall = new EventEmitter<{ initiateDirectedCallData: any }>();
   @Output() edit = new EventEmitter<PresenceContactRegisterListItem>();

   getRouterLink(id: number) {
      return `/${presenceContactsRoute}/${id}`;
   }

   onInitiateDirectedCall(presenceContact: any) {
      const initiateDirectedCallData = {
         Extension: this.currentUser.extension?.number,
         CompanyCode: this.currentUser.shortname,
         Destination: presenceContact.extension.number,
      };
      this.initiateDirectedCall.emit({ initiateDirectedCallData: initiateDirectedCallData });
   }

   onRowClick(entity: PresenceContactRegisterListItem) {
      this.onEditClick(entity);
   }

   onEditClick(entity: PresenceContactRegisterListItem) {
      this.edit.emit(entity);
   }

   get isCallDisabledForAnyContact(): boolean {
      return this.dataSource.some(
         (contact) => contact.extension.number === this.currentUser.extension?.number && contact.onCall === true
      );
   }

   get hasEditingRegisterPrivileges(): boolean {
      return this.presenceContactPrivileges.canEditPhones || this.editPresenceContactPrivileges.canEdit;
   }

   commaSeperatedDepartmentNames(department): string {
      return department?.map((d) => d.department.name).join(', ');
   }
}
